module.exports = __webpack_public_path__ + "static/img/二维码.f6b7e98e.jpeg";